import React from 'react'
import { Box, Chip } from '@material-ui/core'
import { useStyles } from './SchoolIndexChips_style'
import { FormattedMessage } from 'react-intl'

const SchoolIndexChips = (props) => {
    const { schoolsRef, videoRef, newsRef, programNewsRef } = props
    const classes = useStyles()

    const scrollToRef = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' })
    }

    const renderChip = (labelId, ref) => {
        return (
            <Chip
                classes={{ root: classes.chipRoot, label: classes.chipLabel }}
                style={{ backgroundColor: 'var(--background-grey-light)' }}
                className={classes.chip}
                label={<FormattedMessage id={labelId}/>}
                key={`school-index-chip-${labelId}`}
                color='var(--foreground-grey-dark)'
                onClick={() => scrollToRef(ref)}
            />
        )
    }

    return (
        <Box className={classes.chips}>
            <FormattedMessage id='school_index.chips.title' />
            {renderChip('school_index.chips.schools', schoolsRef)}
            {/*{renderChip('school_index.chips.videos', videoRef)}*/}
            {renderChip('school_index.chips.school_news', newsRef)}
            {renderChip('school_index.chips.program_news', programNewsRef)}
        </Box>
    )
}

export default SchoolIndexChips
